import { Layout } from "antd";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import PageHeader from "../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";
import ContentErrorUi from "../../components/errorBoundary/contentErrorUi";
const { Content } = Layout;

const PreviewQuiz = () => {
  return (
    <Layout id="app-layout">
      <ErrorBoundary FallbackComponent={ContentErrorUi} onReset={() => {}}>
        <PageHeader hideSideNav={true} />
      </ErrorBoundary>
      <Content>
        <div className="main-content-wrapper">
            
        </div>
      </Content>
    </Layout>
  );
};

export default PreviewQuiz;
